<template>
  <div class="u-agg-aii-lbox" style="font-size: 12px;">
    <div class="u-agg-aii-legend">
      <div class="u-agg-aii-legend-item">
        <b class="u-agg-aii-block" style="background-color: #0a9bfc;"></b>
        <span>Q1</span>
      </div>
      <div class="u-agg-aii-legend-item">
        <b class="u-agg-aii-block" style="background-color: #31c9e8;"></b>
        <span>Q2</span>
      </div>
      <div class="u-agg-aii-legend-item">
        <b class="u-agg-aii-block" style="background-color: #54dd87;"></b>
        <span>Q3</span>
      </div>
      <div class="u-agg-aii-legend-item">
        <b class="u-agg-aii-block" style="background-color: #913fe7;"></b>
        <span>Q4</span>
      </div>
      <div style="flex: auto;"></div>
    </div>
    <div ref="container" class="chart-container"></div>
  </div>

</template>

<script setup>
import {onMounted, ref, watchEffect} from "vue";
import * as echarts from 'echarts';
import {landAreaFormat} from "@/tool/number";
const props = defineProps({
  data: Array
})
const container = ref();

// 挂载后执行
watchEffect(init)
// 属性改变后执行
onMounted(init)


function parseData(data, fn){
  return data.map(e => fn(e));
}

function init(){
  if(!container.value){
    return;
  }
  const years = parseData(props.data, (e) => e['year'])
  const Q1 = parseData(props.data, (e) => e['Q1'])
  const Q2 = parseData(props.data, (e) => e['Q2'])
  const Q3 = parseData(props.data, (e) => e['Q3'])
  const Q4 = parseData(props.data, (e) => e['Q4'])
  const total = parseData(props.data, (e) => e['total'])
  const app = {};
  const myChart = echarts.init(container.value);
  const posList = [
    'left',
    'right',
    'top',
    'bottom',
    'inside',
    'insideTop',
    'insideLeft',
    'insideRight',
    'insideBottom',
    'insideTopLeft',
    'insideTopRight',
    'insideBottomLeft',
    'insideBottomRight'
  ];
  app.configParameters = {
    rotate: {
      min: -90,
      max: 90
    },
    align: {
      options: {
        left: 'left',
        center: 'center',
        right: 'right'
      }
    },
    verticalAlign: {
      options: {
        top: 'top',
        middle: 'middle',
        bottom: 'bottom'
      }
    },
    position: {
      options: posList.reduce(function (map, pos) {
        map[pos] = pos;
        return map;
      }, {})
    },
    distance: {
      min: 0,
      max: 100
    }
  };
  app.config = {
    rotate: 90,
    align: 'left',
    verticalAlign: 'middle',
    position: 'insideBottom',
    distance: 15,
    onChange: function () {
      const labelOption = {
        show: false,
        rotate: app.config.rotate,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        position: app.config.position,
        distance: app.config.distance
      };
      myChart.setOption({
        series: [
          {
            label: labelOption
          },
          {
            label: labelOption
          },
          {
            label: labelOption
          },
          {
            label: labelOption
          }
        ]
      });
    }
  };

  const barGap = 1;
  const markLine = {
    lineStyle: { color: '#fff' }
  }
  const labelOption = {
    show: false,
    position: app.config.position,
    distance: app.config.distance,
    align: app.config.align,
    verticalAlign: app.config.verticalAlign,
    rotate: app.config.rotate,
    formatter: '{c}{name|{a}}',
    fontSize: 14,
    rich: {
      name: {}
    }
  };

  const option = {
    grid: {
      top: 40,
      bottom: 60,
      left: 60,
      right: 60,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter(a) {
        let year = a[0].axisValue;
        let html = '';
        a.forEach((item, index) => {
          let px = '（万㎡）'
          let val = landAreaFormat(item.value);
          let x = '';
          if (index === 0) {
            x = `<div class='g-chart-icon g-chart-icon-block' style='background:#0a9bfc; border-radius: 40%;'></div>`
          } else if (index === 1) {

            x = `<div class='g-chart-icon g-chart-icon-block' style='background:#31c9e8; border-radius: 40%;'></div>`
          }else if (index === 2) {
            x = `<div class='g-chart-icon g-chart-icon-block' style='background:#54dd87; border-radius: 40%;'></div>`
          }else if (index === 3) {
            x = `<div class='g-chart-icon g-chart-icon-block' style='background:#913fe7; border-radius: 40%;'></div>`
          }
          html += `
                    <div class='g-chart-item'>
                        ${x}
                        <span><b>${item.seriesName}：</b>${val}${px}</span>
                    </div>
                    `
        })
        return `
            <div>
                <p class='g-chart-title' ><b>${year}</b></p>
                <div class='g-chart-list'>
                    ${html}
                </div>
            </div>
        `
      }
    },
    // legend: {
    //   data: ['Q1', 'Q2', 'Q3', 'Q4']
    // },
    xAxis: [
      {
        type: 'category',
        data: years,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        boundaryGap: ['30%', '30%'],
        splitArea: {
          show: true,
          interval: 1,
          areaStyle: {
            opacity: 0.4,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(10, 155, 252, 0.8)'
              },
              {
                offset: 1,
                color: 'rgba(255, 255, 255, 0)'
              }
            ])
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            width: 20,
            color: '#fff'
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: "季度预计增量（万㎡）",
        nameTextStyle: {
          color: "#aaa",
          nameLocation: "start",
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine:{
          show:false
        },
        z: 4,
      },
      {
        type: 'value',
        name: "全年预计增量（万㎡）",
        nameTextStyle: {
          color: "#aaa",
          nameLocation: "start",
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine:{
          show:false
        },
        z: 2
      },
    ],
    series: [
      {
        name: 'Q1',
        type: 'bar',
        barGap: barGap,
        label: labelOption,
        itemStyle:{ borderRadius: 10, color: '#0a9bfc' },
        emphasis: {
          focus: 'series'
        },
        data: Q1,
        barWidth: 20,
        markLine,
        yAxisIndex: 0
      },
      {
        name: 'Q2',
        type: 'bar',
        label: labelOption,
        itemStyle:{ borderRadius: 10, color: '#31c9e8' },
        emphasis: {
          focus: 'series'
        },
        barGap: barGap,
        data: Q2,
        barWidth: 20,
        markLine,
        yAxisIndex: 0
      },
      {
        name: 'Q3',
        type: 'bar',
        label: labelOption,
        barGap: barGap,
        itemStyle: { borderRadius: 10, color: '#54dd87' },
        emphasis: {
          focus: 'series'
        },
        data: Q3,
        barWidth: 20,
        markLine,
        yAxisIndex: 0
      },
      {
        name: 'Q4',
        type: 'bar',
        label: labelOption,
        barGap: barGap,
        itemStyle: { borderRadius: 10, color: '#913fe7' },
        emphasis: {
          focus: 'series'
        },
        data: Q4,
        barWidth: 20,
        markLine,
        yAxisIndex: 0
      },
      {
        name: '全年合计',
        type: 'line',
        data: total,
        label: {
          show: true,
          formatter: '{c}万㎡'
        },
        itemStyle: {
          color: 'rgba(255, 255, 255, 0)'
        },
        yAxisIndex: 1,
        showSymbol: false
      }
    ]
  };

  option && myChart.setOption(option);
}
</script>

<style lang="less" scoped>
.chart-container{
  flex: auto;
  min-height: 0;
}

.u-agg-aii-lbox{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.u-agg-aii-legend {
  display: flex;
  margin-top: 10px;
  margin-bottom: 16px;


.u-agg-aii-legend-item {
  display: flex;
  align-items: center;
  margin-right: 20px;

.u-agg-aii-block {
  width: 10px;
  height: 10px;
  border-radius: 4px;
  margin-right: 5px;
}

.u-agg-aii-xx {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  position: relative;

div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;

}

span {
  position: absolute;
  width: 16px;
  height: 2px;
  top: 50%;
  left: 50%;
  margin-left: -8px;
  margin-top: -1px;
}


}

span {
  color: #666;
}
}
}

.u-agg-chart-total-content {
  height: 100%;
}

.g-chart-item {
  display: flex;
  align-items: center;
  font-size: 12px;

.g-chart-icon {
  margin-right: 10px;

&.g-chart-icon-block {
   width: 10px;
   height: 10px;
   border-radius: 2px;
 }

&.g-chart-icon-line {
   width: 10px;
   height: 10px;
   position: relative;
   border-radius: 50%;

div {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid;
  background: #fff;
}

span {
  position: absolute;
  height: 2px;
  top: 50%;
  left: 50%;
  width: 16px;
  margin-left: -8px;
  margin-top: -1px;
}
}
}
}
</style>